// extracted by mini-css-extract-plugin
export default {"integrationsPage":"IntegrationsPage_integrationsPage__uh1yw","subtitle":"IntegrationsPage_subtitle__SF9fC","tileList":"IntegrationsPage_tileList__ERo5S"};